"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Field = react_1.default.forwardRef(function (props, ref) {
    var loading = props.loading, error = props.error, className = props.className, children = props.children;
    if (loading) {
        return (react_1.default.createElement("div", { ref: ref, className: className }, "na\u010D\u00EDt\u00E1n\u00ED"));
    }
    if (error) {
        return (react_1.default.createElement("div", { ref: ref, className: className }, error));
    }
    return (react_1.default.createElement("div", { ref: ref, className: className }, children));
});
Field.defaultProps = {
    loading: false,
    error: undefined,
    className: undefined,
};
exports.default = styled_components_1.default(Field)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var noStyles = _a.noStyles, topAlign = _a.topAlign;
    return !noStyles && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      @media only screen and (max-width: 658px) {\n        margin-top: 6px;\n      }\n\n      & > *:first-child {\n        flex: 2;\n        @media only screen and (max-width: 500px) {\n          width: 100%;\n        }\n      }\n\n      & > *:last-child {\n        flex: 3;\n        @media only screen and (max-width: 500px) {\n          width: 100%;\n        }\n      }\n      align-items: ", ";\n      min-height: 50px;\n      & + & {\n        margin-top: 1em;\n      }\n      @media only screen and (max-width: 500px) {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: start;\n        input {\n          width: 100%;\n        }\n      }\n      @media only screen and (max-width: 460px) {\n        margin-bottom: 20px;\n      }\n    "], ["\n      display: flex;\n      @media only screen and (max-width: 658px) {\n        margin-top: 6px;\n      }\n\n      & > *:first-child {\n        flex: 2;\n        @media only screen and (max-width: 500px) {\n          width: 100%;\n        }\n      }\n\n      & > *:last-child {\n        flex: 3;\n        @media only screen and (max-width: 500px) {\n          width: 100%;\n        }\n      }\n      align-items: ", ";\n      min-height: 50px;\n      & + & {\n        margin-top: 1em;\n      }\n      @media only screen and (max-width: 500px) {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: start;\n        input {\n          width: 100%;\n        }\n      }\n      @media only screen and (max-width: 460px) {\n        margin-bottom: 20px;\n      }\n    "])), topAlign ? 'top' : 'center');
});
var templateObject_1, templateObject_2;
